import React, { Component } from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

import MenuContainer from './MenuContainer'
import MenuItem from './MenuItem'

const Container = styled.div`
  z-index: 25;
  position: relative;
  width: 100%;
  height: 100%;
  /* margin-right: ${props => props.tallContainer && !props.isMobile ? '36px' : '0'}; */
  display: flex;
  flex-direction:column;
  align-items: center;
  justify-content: center;
  ${props => props.height ? `height: ${props.height}px;` : null}
`

const Clickable = styled.button.attrs({ type: 'button' })`
  ${props => (props.isMobile ? null : 'cursor: pointer;')}
  border: none;
  height: 100%;
  /* width: ${props => props.tallContainer ? '140px' : '48px'};
  ${props => props.isMobile ? 'width: 114px;' : null} */
  width: 100%;
  padding: 0;
  ${'' /* margin: ${props => props.isMobile ? '0 10px 10px 0' : '0 5px 0 0'}; */}
  background: none;
  transition: opacity 0.4s ease;
  outline: none;
  display: flex;
  flex-direction:column;
  align-items: center;
  justify-content: center;
  ${'' /* :focus {
    border: solid 1px ${props => props.theme.colors.primary};
  } */}
`

class ImageContextMenu extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isOpen: false
    }
  }

  // eslint-disable-next-line
  toggleOpen = () => this.setState({ isOpen: !this.state.isOpen })

  setOpen = () => this.setState({ isOpen: true })

  setClosed = () => this.setState({ isOpen: false })

  render() {
    const { items, children, isMobile } = this.props
    const buttonActions = {}
    // buttonActions.onClick = this.toggleOpen
    // buttonActions.onMouseEnter = this.setOpen
    // buttonActions.onFocus = this.setOpen
    // buttonActions.onBlur = this.setClosed
    if (isMobile) {
      buttonActions.onTouchStart = this.toggleOpen
    } else {
      buttonActions.onClick = this.toggleOpen
      // buttonActions.onMouseEnter = this.setOpen
      // buttonActions.onMouseLeave = this.setClosed
      // buttonActions.onFocus = this.setOpen
      // buttonActions.onBlur = this.setClosed
    }

    const containerOptions = {}
    containerOptions.onMouseLeave = this.setClosed
    buttonActions.onBlur = this.setClosed

    return (
      <Container 
        height={this.props.height} 
        tallContainer={this.props.tallContainer}
        isMobile={isMobile}
      >
        <Clickable isMobile={isMobile} tallContainer={this.props.tallContainer} {...buttonActions}>{children}</Clickable>
        <MenuContainer
          isMobile={isMobile}
          key="container"
          pose={this.state.isOpen ? 'opened' : 'closed'}
          tallContainer={this.props.tallContainer}
          {...containerOptions}
        >
          {items.map(item => {
            return (
              <MenuItem
                key={item.text}
                onClick={item.onClick}
                serious={item.serious || false}
              >
                {item.text}
              </MenuItem>
            )
          })}
        </MenuContainer>
      </Container>
    )
  }
}

ImageContextMenu.defaultProps = {
  isMobile: false,
  tallContainer: false
}

ImageContextMenu.propTypes = {
  isMobile: PropTypes.bool,
  tallContainer: PropTypes.bool,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string.isRequired,
      onClick: PropTypes.func.isRequired,
      serious: PropTypes.bool
    })
  ).isRequired
}

export default ImageContextMenu
